<template>
  <div class="container">
    <div
      class="img-container"
      v-for="(imgsrc, index) in imgTarjetas"
      v-bind:key="imgsrc"
    >
      <img :src="imgsrc" alt="BBVA" />

      <div class="card-info">
        <p class="card-name">{{ armadoCards[index].titulo }}</p>
        <span class="card-subtitle" :data-obfuscate="quantumObfuscate">{{
          armadoCards[index].subtitulo
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { nombresTarjetasPorCodigo } from "@/config/constants/packagesCodes.js";
import { formatDinero } from "@/utils";
export default {
  name: "ProductImageContainer",
  props: {
    tarjetas: {
      type: Array,
      default: function() {
        return [];
      }
    },
    listadoTarjetas: {
      type: Array,
      default: function() {
        return [];
      }
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  computed: {
    imgTarjetas() {
      return this.tarjetas.map(codigo => {
        return require(`@/assets/img/ofertaNomina/tarjetas/${codigo}.png`);
      });
    },
    nombreCliente() {
      let { nombre, apellido } = this.$store.state.consulta;
      let nombres = nombre.split(" ");
      let apellidos = apellido.split(" ");

      return `${nombres[0].slice(0, 12)} ${apellidos[0].slice(0, 12)}`;
    },
    esCliente() {
      const { esCliente } = this.$store.getters.getDataOferta() || {};
      return esCliente?.respuesta === "CLIENTE";
    },
    armadoCards() {
      let listadoTarjetasAprobadas = [];
      let tarjetasAprobadas = this.listadoTarjetas;

      tarjetasAprobadas.forEach(tarjetaAprobada => {
        let cardInfoDeTarjetas = {
          titulo: "",
          subtitulo: ""
        };

        cardInfoDeTarjetas.titulo = nombresTarjetasPorCodigo(
          tarjetaAprobada.tipoTarjeta
        );

        cardInfoDeTarjetas.subtitulo =
          "Limite: $" + formatDinero(tarjetaAprobada.limite);

        listadoTarjetasAprobadas.push(cardInfoDeTarjetas);
      });

      //-------------card de TD

      let cardInfoTD = {
        titulo: "Visa Debito",
        subtitulo: "Vinculada a tu caja de ahorro"
      };
      if (this.esCliente) {
        cardInfoTD.subtitulo = "Caja de ahorro en pesos";
      }

      listadoTarjetasAprobadas.push(cardInfoTD);

      return listadoTarjetasAprobadas;
    }
  }
};
</script>

<style scoped>
img {
  display: block;
  width: 100%;
  max-width: 200px;
  height: auto;
  border-radius: 10px;
  box-shadow: none;
}

.img-container {
  position: relative;
  z-index: 1;
}

.custom-name {
  position: absolute;
  left: 4.2%;
  width: 100%;
  bottom: 4%;
  z-index: 1000;
  text-transform: uppercase;
}

.custom-name text {
  fill: white;
  text-shadow: 1px 1px rgba(0, 0, 0, 0.48);
  font-family: monospace;
}

.container {
  display: flex;
  justify-content: space-around;
  position: relative;
}

.container.triple {
  justify-content: flex-end;
  padding-top: 10%;
}

.container.triple .img-container {
  width: 44%;
}

.container.triple .img-container:first-child {
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
}

.container.triple .img-container:nth-child(2) {
  margin-right: 4%;
}

.card-info {
  display: flex;
  padding: 10px 15px;
  flex-direction: column;
  text-align: center;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}

.card-info span {
  font-weight: lighter;
  font-size: 12px;
}
.card-info p.card-name {
  color: #121212;
  line-height: 24px;
  font-size: 16px;
  margin: 10px 0 0 0;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}

.card-info p.card-name,
.card-info span.card-subtitle {
  font-weight: 350;
}

.card-info span.card-subtitle {
  font-size: 12px;
  line-height: 16px;
  color: #666666;
}

@media screen and (max-width: 1024px) {
  .img-container {
    margin-left: auto;
    margin-right: auto;
    width: 215px;
  }
}

@media screen and (max-width: 600px) {
  .img-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  .img-container img {
    width: 70px;
    height: 48px;
    border-radius: 0;
  }

  .img-container div.card-info {
    display: flex;
    align-items: flex-start;
  }

  .img-container .card-info p.card-name {
    font-size: 15px;
    line-height: 24px;
  }
}
</style>
